import React, { useState, useEffect } from 'react';
import { buscarPerfis } from '../services/perfisService';

const estados = ['Mato Grosso'];

const cidadesPorEstado = {
  'Mato Grosso': [
    'Cuiabá',
    'Várzea Grande',
    'Rondonópolis',
    'Sinop',
    'Sorriso',
  ],
};

const BuscarSociosPage = () => {
  const [busca, setBusca] = useState('');
  const [estadoSelecionado, setEstadoSelecionado] = useState('');
  const [cidadeSelecionada, setCidadeSelecionada] = useState('');
  const [resultados, setResultados] = useState([]);
  const [sugestoes, setSugestoes] = useState([]);

  useEffect(() => {
    const delay = setTimeout(async () => {
      if (busca.length > 1) {
        const perfis = await buscarPerfis(
          busca,
          estadoSelecionado,
          cidadeSelecionada
        );
        setSugestoes(perfis);
      } else {
        setSugestoes([]);
      }
    }, 300);
    return () => clearTimeout(delay);
  }, [busca, estadoSelecionado, cidadeSelecionada]);

  const getIniciais = (nome) => {
    const partes = nome.trim().split(' ');
    if (partes.length === 1) return partes[0][0];
    return partes[0][0] + partes[1][0];
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-4">Buscar Sócios e Parcerias</h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-2 mb-4 relative">
        <div className="col-span-1 relative">
          <input
            type="text"
            placeholder="Nome, usuário, CRECI ou CNPJ..."
            className="border p-2 rounded w-full"
            value={busca}
            onChange={(e) => setBusca(e.target.value)}
          />
          {sugestoes.length > 0 && (
            <div className="absolute z-10 bg-white border w-full mt-1 rounded shadow max-h-64 overflow-y-auto">
              {sugestoes.map((perfil) => (
                <div
                  key={perfil.id}
                  className="p-2 hover:bg-gray-100 cursor-pointer flex items-center gap-2"
                  onClick={() => setResultados([perfil])}
                >
                  <div className="w-8 h-8 bg-blue-600 text-white rounded-full flex items-center justify-center text-sm">
                    {getIniciais(perfil.nome)}
                  </div>
                  <div>
                    <p className="text-sm font-medium">{perfil.nome}</p>
                    <p className="text-xs text-gray-500">@{perfil.username}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <select
          value={estadoSelecionado}
          onChange={(e) => {
            setEstadoSelecionado(e.target.value);
            setCidadeSelecionada('');
          }}
          className="border p-2 rounded w-full"
        >
          <option value="">Selecione o estado</option>
          {estados.map((estado) => (
            <option key={estado} value={estado}>
              {estado}
            </option>
          ))}
        </select>

        <select
          value={cidadeSelecionada}
          onChange={(e) => setCidadeSelecionada(e.target.value)}
          className="border p-2 rounded w-full"
        >
          <option value="">Selecione a cidade</option>
          {(cidadesPorEstado[estadoSelecionado] || []).map((cidade) => (
            <option key={cidade} value={cidade}>
              {cidade}
            </option>
          ))}
        </select>

        <button
          onClick={() => setResultados(sugestoes)}
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
        >
          Buscar
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {resultados.map((perfil) => (
          <div
            key={perfil.id}
            className="border p-4 rounded shadow-sm bg-white flex gap-3 items-start"
          >
            {perfil.foto ? (
              <img
                src={perfil.foto}
                alt={perfil.nome}
                className="w-24 h-24 rounded-full object-cover"
              />
            ) : (
              <div className="w-24 h-24 rounded-full bg-blue-600 flex items-center justify-center text-white font-bold text-2xl">
                {getIniciais(perfil.nome)}
              </div>
            )}

            <div className="flex-1">
              <h2 className="font-semibold">{perfil.nome}</h2>
              <p className="text-sm text-gray-600">@{perfil.username}</p>
              <p className="mt-1 text-gray-700">{perfil.tipo}</p>
              <p className="text-gray-700">{perfil.cidade}</p>
              <p className="text-gray-700">{perfil.estado}</p>
              <p className="text-gray-700">{perfil.especialidade}</p>
              {perfil.creci && (
                <p className="text-gray-500">CRECI: {perfil.creci}</p>
              )}
              {perfil.cnpj && (
                <p className="text-gray-500">CNPJ: {perfil.cnpj}</p>
              )}
              <div className="mt-2 flex gap-4 text-sm">
                <span className="flex items-center gap-1">
                  <span role="img" aria-label="Conexões">
                    👥
                  </span>
                  {perfil.parcerias} parcerias
                </span>
                <span className="flex items-center gap-1">
                  <span role="img" aria-label="Sócios">
                    🏆
                  </span>
                  {perfil.socios} sócios
                </span>
              </div>
              <button className="mt-3 w-full bg-blue-600 hover:bg-blue-700 text-white py-1 rounded">
                Ver Perfil
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BuscarSociosPage;
